// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tinyPhoto[data-v-d48c6b9c]{width:100%;height:71%}.btnActive[data-v-d48c6b9c]{background-color:#f5f5f5}.btnActive[data-v-d48c6b9c]:active{background-color:#76d4e3}.closeIconPos[data-v-d48c6b9c]{position:absolute;top:2px;right:2px;font-size:20px;color:#000;cursor:pointer}.closeIconPos[data-v-d48c6b9c]:active{color:#ebebeb}.selectBorder[data-v-d48c6b9c]{border:1px solid #ff9503}.retryHover[data-v-d48c6b9c]:hover{background-color:rgba(17,163,144,.6)}", ""]);
// Exports
module.exports = exports;
